import React from 'react'

import CourseDetails from 'screens/AuthenticatedArea/CourseDetails'

export default function MVUAcceleratorCourseDetails() {
  return <CourseDetails portal="accelerator" />
}
